import { Pagination, PaginationProps, styled } from "@mui/material";

const StyledPagination = styled(Pagination)(({ theme }) => ({
    '& .MuiPaginationItem-root': {
        color: theme.palette.dsBase.v200,
        borderColor: theme.palette.dsBase.v200,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.dsPrimary.v200,
            color: theme.palette.dsBase.v100,
            '&:hover': {
                backgroundColor: theme.palette.dsSecondaryBrown.v200,
            },
        },
    },
}));

export interface BybPaginationProps extends Omit<PaginationProps, 'variant'> {
    size?: 'small' | 'medium' | 'large';
    color?: 'primary' | 'secondary';
}

const BybPagination = ({ 
    size = 'medium',
    color = 'primary',
    ...props 
}: BybPaginationProps) => {
    return (
        <StyledPagination
            variant="outlined"
            shape="rounded"
            size={size}
            color={color}
            {...props}
        />
    );
};

export default BybPagination; 